<div class="appContentsContainer">
  <form
    [formGroup]="rulesTemplate"
    (ngSubmit)="onSave()"
    class="formGroup container halfForm"
  >
    <div class="pageTitle" *ngIf="operation === 'creacion'">
      {{ "templatesRules.titleCreate" | translate }}
    </div>
    <div class="pageTitle" *ngIf="operation === 'edicion'">
      {{ "templatesRules.titleEdit" | translate }}
    </div>
    <div class="lineGradient"></div>
    <div class="row shortRowAux">
      <div class="itemContainer col">
        <div class="seachLabel inputLabelContainer ajustLabel">
          <div class="inputLabel">
            <label>Marco legal </label>
          </div>
        </div>
        <div class="inputContainer">
          <input
            type="text"
            value="{{ rulesTemplate.value.reMarcolegal }}"
            [readonly]="true"
          />
        </div>
      </div>
      <div class="itemContainer col">
        <div class="seachLabel inputLabelContainer ajustLabel">
          <div class="inputLabel">
            <label>Tipo de doc. </label>
          </div>
        </div>
        <div class="inputContainer">
          <input
            type="text"
            value="{{ rulesTemplate.value.reTcertificado }}"
            [readonly]="true"
          />
        </div>
      </div>
    </div>
    <div class="row shortRowAux">
      <div class="itemContainer col">
        <div class="seachLabel inputLabelContainer ajustLabel">
          <div class="inputLabel">
            <label>Reforma</label>
          </div>
        </div>
        <div class="inputContainer">
          <input
            type="text"
            value="{{ rulesTemplate.value.reReforma }}"
            [readonly]="true"
          />
        </div>
      </div>
      <div class="itemContainer col">
        <div class="seachLabel inputLabelContainer ajustLabel">
          <div class="inputLabel">
            <label>Número de regla</label>
          </div>
        </div>
        <div class="inputContainer">
          <input
            type="text"
            value="{{ rulesTemplate.value.reIndice }}"
            [readonly]="true"
          />
        </div>
      </div>
    </div>

    <div class="row shortRowAux">
      <div class="itemContainer col">
        <div class="seachLabel inputLabelContainer ajustLabel">
          <div class="inputLabel">
            <label id="reDesc" for="reDesc">Descripción</label>
          </div>
        </div>
        <div class="inputContainer">
          <input type="text" formControlName="reDesc" maxlength="128" />
        </div>
      </div>

      <div class="itemContainer col">
        <div class="seachLabel inputLabelContainer ajustLabel">
          <div class="inputLabel">
            <label id="rePlantilla" for="rePlantilla">Plantilla activada</label>
          </div>
        </div>
        <div class="inputContainer">
          <app-input-selector-with-search
            [list]="activedTemplates"
            [fields]="['paId', 'paDescr']"
            [id]="'paId'"
            [item]="rulesTemplate.value.rePlantilla"
            (sendValue)="valueSelector($event)"
          ></app-input-selector-with-search>
          <div class="supIndexRequestAux">*</div>
        </div>
      </div>
    </div>
    <div class="row shortRowAux">
      <div class="col marginAdjustButtons">
        <button
          class="col buttonSize"
          type="button"
          (click)="addToTextarea('AND')"
        >
          AND
        </button>
        <button
          class="col buttonSize"
          type="button"
          (click)="addToTextarea('OR')"
        >
          OR
        </button>
        <button
          class="col buttonSize"
          type="button"
          (click)="addToTextarea('>')"
        >
          >
        </button>
        <button
          class="col buttonSize"
          type="button"
          (click)="addToTextarea('<')"
        >
          <
        </button>
        <button
          class="col buttonSize"
          type="button"
          (click)="addToTextarea('<=')"
        >
          <=
        </button>
        <button
          class="col buttonSize"
          type="button"
          (click)="addToTextarea('>=')"
        >
          >=
        </button>
        <button
          class="col buttonSize"
          type="button"
          (click)="addToTextarea('=')"
        >
          =
        </button>
        <button
          class="col buttonSize"
          type="button"
          (click)="addToTextarea('<>')"
        >
          <>
        </button>
        <button
          class="col buttonSize"
          type="button"
          (click)="addToTextarea('LIKE')"
        >
          LIKE
        </button>
        <button
          class="col buttonSize2"
          type="button"
          (click)="addToTextarea('NOT LIKE')"
        >
          NOT LIKE
        </button>
        <button
          class="col buttonSize"
          type="button"
          (click)="addToTextarea('+')"
        >
          +
        </button>
        <button
          class="col buttonSize"
          type="button"
          (click)="addToTextarea('-')"
        >
          -
        </button>
        <button
          class="col buttonSize"
          type="button"
          (click)="addToTextarea('*')"
        >
          *
        </button>
        <button
          class="col buttonSize"
          type="button"
          (click)="addToTextarea('/')"
        >
          /
        </button>
        <button
          class="col buttonSize"
          type="button"
          (click)="addToTextarea('(')"
        >
          (
        </button>
        <button
          class="col buttonSize"
          type="button"
          (click)="addToTextarea(')')"
        >
          )
        </button>
        <button
          class="col buttonSize"
          type="button"
          (click)="addToTextarea('VAR')"
        >
          VAR
        </button>
        <button
          class="col buttonSize2 ml-4"
          (click)="validateEcuacion()"
          type="button"
        >
          Validar
        </button>
      </div>
    </div>

    <div class="row shortRowAux extraHeight">
      <div class="itemContainer col extraHeight">
        <div
          class="seachLabel inputLabelContainer ajustLabel extraHeight thinWidth"
        >
          <div class="inputLabel extraHeight">
            <label id="reEcuacion" for="rePlantilla" class="extraHeight"
              >Ecuación</label
            >
          </div>
        </div>
        <div class="inputContainer">
          <textarea
            class="textarea"
            formControlName="reEcuacion"
            (focus)="changeEcuacion()"
            (focusout)="chechIfHasChanged()"
            maxlength="512"
          ></textarea>
          <div class="supIndexRequest">*</div>
        </div>
      </div>
    </div>

    <div class="buttonsGroup">
      <div class="backButton">
        <button
          class="formButtonBack"
          *ngIf="rulesTemplate.pristine"
          type="button"
          (click)="goList()"
        >
          <em class="fas fa-caret-square-left"></em>
        </button>
        <button
          class="formButtonBack"
          *ngIf="!rulesTemplate.pristine"
          [swal]="confirmSwal"
          type="button"
        >
          <em class="fas fa-caret-square-left"></em>
        </button>
      </div>
      <div class="okButton">
        <div class="centerButton">
          <button class="formButtonOk" type="submit">
            {{ "commons.ok" | translate }}
          </button>
        </div>
      </div>
    </div>

    <swal
      #confirmSwal
      html="<strong>Tienes cambios sin guardar <br/> ¿Quieres volver sin guardar?</strong>"
      icon="warning"
      [showCancelButton]="true"
      [swalOptions]="{
        confirmButtonText: 'Aceptar',
        cancelButtonText: 'Cancelar',
        allowEscapeKey: false,
        allowOutsideClick: false
      }"
      [focusCancel]="true"
      (confirm)="goList()"
    >
    </swal>
  </form>
</div>
